// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:45:09+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            956fce0beccd267c5052a078a2d6972c
//    Signature:      eyJpdiI6IjIwbVNOb0NrNUpMelpaWlhOWHNLakE9PSIsInZhbHVlIjoibGJrZmFaOHA2TWtvZEtLd09MNndcL2RRdmtQbjZQbzJqZFkwT0tSem5SelVPYWd5eUx6K1pTS2l5RkpEVGJFXC9RbnpVNDZtblB1anFNeVZtU2JPbkV3djI0ZXhPSUc5WEQrdVhcL0FHVlJaYzFURm9mMHJcL2w4aXVPV0FISytGZ2xEemFabGFNczR3dTdvN1hkajdHQ0NsNUdldWVwemw2NmZyMG1cL0hQeHhCOU9KTTExVWYxT2QxWlZBNmtiN0k1NU9BQzhQaklKWEh5dWloYmlFWkxiRmpJTjlcL3poQm1tRXkyWUIrTDBkdDA3bEhraE15dnRjVjB3SVpmRldQMEVRQlNBUEtEdkFRTDZvTnlmbFphSEp4cFwvbThLVGNEZVhPcFpFbVJoZ2JQbVdLZWxWRmFzdCtpejl2QVwvcHBIRkt0aVVxamFsYWxDZXg0WXpTSzZCWW50NFBiN3JnUk9wQ2JKYUdJTENWTm55NHl5NXRxa2tjY3JUOHZYSWVadVlkSzJGdkpsNjNkNGswM1dnZVA3MWM5VU1RPT0iLCJtYWMiOiI1MTE5YzdhYjNiMWJhMmQ1ZWMzZWNhZjY0YmVlMDM3OTMxNmZhOWI3ZDMwN2RkN2MyZjQ5OGVkZTNjMTg0Y2Y0In0=
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section => {
        var elm = document.getElementById(section.id);

        if (elm) {
          elm.innerHTML =
           this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));

      if (window.cartSettings.drawerCartEnabled === 'true') {

        const drawTotal = document.querySelector('.total-drawer');
        if (drawTotal) {
          const price = parsedState.price;
          const totalPrice = Number(drawTotal.getAttribute("data-price"));
          const newPrice = price + totalPrice;

          drawTotal.setAttribute("data-price", newPrice);
          drawTotal.innerHTML = '£' + (newPrice / 100);
        }
      }

      //if (this.header) this.header.reveal();
      //this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
